import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchGameCategories } from '../../SearchGameCategories';
import type { ISearchFallbackScenariosProps } from '..';

type DefaultScenarioProps = ISearchFallbackScenariosProps;

export const DefaultScenario: React.FC<DefaultScenarioProps> = ({
  gridOptions,
  handleSearchGameClick,
  sendSearchResultAppearance,
}) => {
  const { t } = useTranslation('lobby');

  useEffect(() => {
    sendSearchResultAppearance({ status: 'empty_results' });
  }, []);

  return (
    <>
      <p>{t('game.likeThis')} 👇</p>
      <SearchGameCategories
        gridOptions={gridOptions}
        handleSearchGameClick={handleSearchGameClick}
      />
    </>
  );
};
